import { render, staticRenderFns } from "./TambahkanPesananPengiriman.vue?vue&type=template&id=0e944f92&scoped=true&"
import script from "./TambahkanPesananPengiriman.vue?vue&type=script&lang=js&"
export * from "./TambahkanPesananPengiriman.vue?vue&type=script&lang=js&"
import style0 from "./TambahkanPesananPengiriman.vue?vue&type=style&index=0&id=0e944f92&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e944f92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTimePicker } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDatePicker,VFlex,VForm,VLayout,VMenu,VSelect,VSpacer,VSubheader,VTextField,VTextarea,VTimePicker})
